<!--
 * @Description: 主标题组件
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <div class="comp-fh-main-title" :key="mainTitle">
    <div class="tag-and-title">
      <jw-tag v-if="objectTitle" class="object_title" size="small" color="blue">{{ objectTitle }}</jw-tag>
      <template v-if="data.entity == 1">
        <jw-tag v-if="data.customerId" size="small" color="green">{{ $t('已转化') }}</jw-tag>
      </template>
      <template v-if="data.entity == 2">
        <jw-tooltip :content="data.qccId ? $t('查看工商信息') : $t('tips.customerIsRequired')" position="rt" mini>
          <span @click="openMessageDialog" style="display: flex"> <qf-icon-business width="20px" height="20px" :color="data.qccId ? 'rgb(var(--primary-6))' : '#C9CDD4'" style="margin-right: 8px; cursor: pointer" /></span>
        </jw-tooltip>
        <!-- 客户成交状态 -->
        <jw-tag v-if="!isNaN(parseFloat(isDealt)) && (isDealt == 1 || isDealt == 2)" color="green" size="small">{{ clientState?.[isDealt] }}</jw-tag>
      </template>
    </div>
    <template v-if="mainTitle">
      <div class="opacity-0" ref="titleRef">{{ mainTitle }}</div>
      <template v-if="getLineClamp() > 1">
        <jw-tooltip :content="mainTitle" position="bottom">
          <div class="title">{{ mainTitle }}</div>
        </jw-tooltip>
      </template>

      <div class="title" v-else>{{ mainTitle }}</div>
    </template>

    <!-- 展开收起 -->
    <template v-if="showRightPart">
      <div class="expand-collapse" @click="handleExpandCollapse" :style="expandCollapseStyle">
        <jw-tooltip :content="expandCollapse ? '收起' : '展开'" position="bottom">
          <qfei-icon-sidebar-outlined class="expand-collapse-icon" />
        </jw-tooltip>
      </div>
    </template>
  </div>
  <!-- 展示关联的工商信息 -->
  <xl-business-message ref="businessmessageRef"></xl-business-message>
</template>

<script setup>
import { computed, ref, inject, reactive, onMounted, watch, nextTick } from 'vue';
import { clientState } from '@/utils/const';
import useEventListener from '@/hooks/event-listener';
const { eventListener } = useEventListener();
import { QfeiIconSidebarOutlined } from '@qfei-design/icons-vue';
const props = defineProps({
  title: {
    //标题
    type: String,
    default: () => ''
  },
  objectTitle: {
    //对象名称
    type: String,
    default: () => ''
  }
});
const data = reactive({
  entity: inject('globalParams')?.entity || inject('defaultParams').entity,
  detailAllFields: inject('detailParams')?.detailAllFields,
  customerId: inject('detailParams')?.customerId,
  qccId: inject('detailParams')?.qccId,
  id: inject('detailParams')?.id
});
const showRightPart = computed(() => inject('detailParams')?.showRightPart.value); //是否展示右侧部分

const isDealt = ref(data.detailAllFields?.isDealt);
const titleRef = ref(null);
const businessmessageRef = ref(); //展示工商信息

const getLineClamp = () => {
  const title = titleRef.value;
  if (!title) {
    return 0;
  }
  const lineHeight = parseInt(window.getComputedStyle(title).lineHeight);
  const height = title.clientHeight;
  return Math.floor(height / lineHeight);
};

const mainTitle = computed(() => props.title);

//展示工商信息
const openMessageDialog = () => {
  if (data.qccId) {
    businessmessageRef.value?.messageShow(data.id);
  }
};

const expandCollapse = inject('detailParams')?.expandCollapse;
const emits = defineEmits(['handleExpand']);
//展开收起
const handleExpandCollapse = () => {
  emits('handleExpand');
};

const expandCollapseStyle = ref({
  left: '0px',
  top: '60px',
  right: null,
  zIndex: 1001
});
const getFixedLeft = () => {
  expandCollapseStyle.value.right = null;
  const getAditPopup = document?.querySelectorAll('.obj-details-drawer');
  if (getAditPopup && getAditPopup?.length > 0) {
    const getlast = getAditPopup[getAditPopup?.length - 1];
    const detailsDrawer = getlast.querySelectorAll('.main-detail')[0];
    const zIndex = Number(getlast.style.zIndex) + 1;
    const left = detailsDrawer?.getBoundingClientRect()?.left + detailsDrawer?.getBoundingClientRect()?.width - 41;
    expandCollapseStyle.value.left = `${left}px`;

    expandCollapseStyle.value.zIndex = zIndex;
  }
};
onMounted(() => {
  if (showRightPart.value) {
    getFixedLeft();
  }
});
watch(
  () => expandCollapse.value,
  (newVal) => {
    if (showRightPart.value) {
      if (newVal) {
        //展开
        nextTick(() => {
          getFixedLeft();
        });
      } else {
        //收起
        expandCollapseStyle.value.left = null;
        expandCollapseStyle.value.right = '-40px';
      }
    }
  },
  { immediate: true }
);
eventListener('resize', getFixedLeft);
</script>
<style scoped lang="less">
@import './index.less';
</style>
